// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom styling for selected day */
.react-datepicker__day--selected {
  background: #dd9122 !important; /* Chakra UI blue */
  color: white !important;
  border: 1px solid #dd9122 !important;
  /* border-radius: 50%; Circular day cells */
}

.react-datepicker__day--today {
  color: #dd9122;
}

.react-datepicker-wrapper {
  width: 100%;
}

/* Custom styling for selected day */
.react-datepicker__day--selected:hover {
  background: #dd9122 !important; /* Chakra UI blue */
  color: white !important;
  /* border-radius: 50%; Circular day cells */
}

/* Custom styling for the hover effect on day cells */
.react-datepicker__day:hover {
  color: #986b3f;
  font-weight: bold;
}

/* Custom header styling */
.react-datepicker__header {
  background-color: #dd9122; /* Chakra UI blue */
  border-bottom: 0;
}

.react-datepicker__current-month,
.react-datepicker__day-name,
.react-datepicker__navigation {
  color: white;
}

/* Styling for the calendar container */
.custom-calendar {
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Today button customization */
.react-datepicker__today-button {
  background-color: #dd9122; /* Chakra UI blue */
  color: white;
}

.react-datepicker__day--disabled:hover,
.react-datepicker__month--disabled:hover,
.react-datepicker__quarter--disabled:hover,
.react-datepicker__year--disabled:hover {
  cursor: default;
  color: #ccc !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/customs/styles.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,8BAA8B,EAAE,mBAAmB;EACnD,uBAAuB;EACvB,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE,8BAA8B,EAAE,mBAAmB;EACnD,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA,qDAAqD;AACrD;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,YAAY;AACd;;AAEA;;;;EAIE,eAAe;EACf,sBAAsB;AACxB","sourcesContent":["/* Custom styling for selected day */\n.react-datepicker__day--selected {\n  background: #dd9122 !important; /* Chakra UI blue */\n  color: white !important;\n  border: 1px solid #dd9122 !important;\n  /* border-radius: 50%; Circular day cells */\n}\n\n.react-datepicker__day--today {\n  color: #dd9122;\n}\n\n.react-datepicker-wrapper {\n  width: 100%;\n}\n\n/* Custom styling for selected day */\n.react-datepicker__day--selected:hover {\n  background: #dd9122 !important; /* Chakra UI blue */\n  color: white !important;\n  /* border-radius: 50%; Circular day cells */\n}\n\n/* Custom styling for the hover effect on day cells */\n.react-datepicker__day:hover {\n  color: #986b3f;\n  font-weight: bold;\n}\n\n/* Custom header styling */\n.react-datepicker__header {\n  background-color: #dd9122; /* Chakra UI blue */\n  border-bottom: 0;\n}\n\n.react-datepicker__current-month,\n.react-datepicker__day-name,\n.react-datepicker__navigation {\n  color: white;\n}\n\n/* Styling for the calendar container */\n.custom-calendar {\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* Today button customization */\n.react-datepicker__today-button {\n  background-color: #dd9122; /* Chakra UI blue */\n  color: white;\n}\n\n.react-datepicker__day--disabled:hover,\n.react-datepicker__month--disabled:hover,\n.react-datepicker__quarter--disabled:hover,\n.react-datepicker__year--disabled:hover {\n  cursor: default;\n  color: #ccc !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
